// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3O-6l","rootNoMargin":"styles_rootNoMargin__3_CNI"};